<template>
  <NavigationHeader :title="wp.title" accent />
</template>

<script>
export default {
  name: 'DonationHeader',
  inject: ['wp']
}
</script>
